import { render, staticRenderFns } from "./RootColumn.vue?vue&type=template&id=a1532004&scoped=true&"
import script from "./RootColumn.vue?vue&type=script&lang=js&"
export * from "./RootColumn.vue?vue&type=script&lang=js&"
import style0 from "./RootColumn.vue?vue&type=style&index=0&id=a1532004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1532004",
  null
  
)

export default component.exports